<div
	class="filterOption row gx-0 flex-nowrap align-items-start"
	[ngClass]="{
		'active pe-none cursor-default': isActive,
		'cursor-pointer': !isActive
	}"
	(click)="onOptionFilterItemClick()"
>

	<!-- RadioButton -->
	<span class="radioButton col-auto me-2">
		<span class="bg"></span>
	</span>

	<!-- Label -->
	<span
		class="col px-0 fs-md label d-inline-block"
		[innerHTML]="label"
	></span>
</div>
